import { Injector } from '@angular/core';
import {
  ActionButtonOutcomesType,
  ButtonActionType,
  NavigationOptionEnum,
  ThreadStatus,
  UiZoneWidgetAttributeConfig,
} from '@finxone-platform/shared/sys-config-types';
import { SupportChatsService } from '../../../services/support-chats-service/support-chats.service';
import { functionCtaType } from '../cta-button-actions.utils';
import { handleRedirection } from '../cta-redirection.utils';
import { WorkflowFormsService } from '@app/finxone-web-frontend/app/lib/services/workflow-forms/workflow-forms.service';

export const supportChatActions: Map<ButtonActionType, functionCtaType> = new Map([
  [
    ButtonActionType.START_A_NEW_SUPPORT_CHAT,
    (injector: Injector, attri: UiZoneWidgetAttributeConfig) => {
      const supportChatsService = injector.get(SupportChatsService);
      const workflowFormsService = injector.get(WorkflowFormsService);

      if (!workflowFormsService.currentPageFormsValid()) {
        //show validation messages on controls
        workflowFormsService.markCurrentPageFormsTouched();
        return;
      }
      supportChatsService.getSupportChatMessageDefault().subscribe({
        next: (defaultMessage) => {
          if (defaultMessage?.enabled && defaultMessage?.text) {
            supportChatsService.setWelcomeMessage(defaultMessage.text);
          }
        },
        error: (error) => {
          console.error('Error fetching support chat message default:', error);
        },
      });

      supportChatsService.setNewChatStatus(true);
      supportChatsService.resetActiveChatId();
      supportChatsService.setActiveChatStatus(ThreadStatus.OPEN);
      const actionNavigationConfig = attri.widgetProperties?.actionNavigationConfigurations;
      if (
        actionNavigationConfig?.[ActionButtonOutcomesType.SUCCESS] &&
        actionNavigationConfig?.[ActionButtonOutcomesType.SUCCESS]?.selectedNavigationOption !==
          NavigationOptionEnum.USE_AS_BLANK
      ) {
        handleRedirection(attri.widgetProperties, injector, ActionButtonOutcomesType.SUCCESS);
      }
    },
  ],
]);
